import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { withStyles } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MoreIcon from "@material-ui/icons/MoreVert";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import classNames from "classnames";
import DrawerLeft from "./DrawerLeft";
import Grid from "@material-ui/core/Grid";
import Star from "@material-ui/icons/Star";
import LibraryAdd from "@material-ui/icons/LibraryAdd";
import { withContext } from "../../common/etgs-context";
import NotificationsIcon from "@material-ui/icons/Notifications";
import Tooltip from "@material-ui/core/Tooltip";
import UserService from "../../user/UserService";
import { emitter } from "../../common/NotificationService";
import { DialogHandler } from "../../components/dialog/controlledDialogHOC";
import ConfirmationDialog from "../../components/dialog/ConfirmationDialog";
import CommonDialog from "../../components/CommonDialog";
import { Box, Typography } from "@material-ui/core";
import { PASSWORD_STATUS } from "../../common/constants/password-status";
import { Alert } from "@material-ui/lab";
import Button from "@material-ui/core/Button";

const drawerWidth = 240;

const styles = theme => ({
    root: {
        width: "100%"
    },
    grow: {
        flexGrow: 1
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20
    },
    title: {
        display: "none",
        [theme.breakpoints.up("sm")]: {
            display: "block"
        }
    },
    sectionDesktop: {
        display: "none",
        [theme.breakpoints.up("md")]: {
            display: "flex"
        }
    },
    sectionMobile: {
        display: "flex",
        [theme.breakpoints.up("md")]: {
            display: "none"
        }
    },
    appBar: {
        position: "absolute",
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    "appBarShift-left": {
        marginLeft: drawerWidth
    },
    "appBarShift-right": {
        marginRight: drawerWidth
    },
    hide: {
        display: "none"
    },
    drawerPaper: {
        position: "relative",
        width: drawerWidth
    },
    drawerHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 8px",
        ...theme.mixins.toolbar
    },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    "content-left": {
        marginLeft: -drawerWidth
    },
    "content-right": {
        marginRight: -drawerWidth
    },
    contentShift: {
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    "contentShift-left": {
        marginLeft: 0
    },
    "contentShift-right": {
        marginRight: 0
    }
});

class Header extends React.Component {

    constructor(props) {
        super(props);
        emitter.on("etgs-notification", etgsNotification => {
            this.setState({ etgsNotification });
        });
    }

    state = {
        anchorEl: null,
        mobileMoreAnchorEl: null,
        etgsNotification: null,
        openDialog: false,
        showCurrentPassword: false,
        showNewPassword: false,
        showRetryNewPassword: false,
        oldPassword: "",
        newPassword: "",
        retryNewPassword: "",
        passwordExpired: (this.props.passwordStatus === PASSWORD_STATUS.PASSWORD_ABOUT_TO_EXPIRE),
        alert: { open: false, message: "" },
        message: { saved: false, noData: false },
        showAlert: true,
        passwordExpiredAcknowledged: sessionStorage.getItem('passwordExpiredAcknowledged') === 'true',

    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (
            !prevState.passwordExpiredAcknowledged &&
            nextProps.passwordStatus === PASSWORD_STATUS.PASSWORD_ABOUT_TO_EXPIRE
        ) {
            return { passwordExpired: true };
        }
        return null;
    }

    deslogearDialogHandler = new DialogHandler();
    handleProfileMenuOpen = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleMenuClose = () => {
        this.setState({ anchorEl: null });
        this.handleMobileMenuClose();
    };

    handleMobileMenuOpen = event => {
        this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    handleMobileMenuClose = () => {
        this.setState({ mobileMoreAnchorEl: null });
    };
    logout = () => {
        this.deslogearDialogHandler.open().then(() => {
            // Limpia datos del almacenamiento local y de sesión
            localStorage.clear();
            sessionStorage.clear();

            localStorage.setItem("logout", Date.now()); // Notifica el logout en otras pestañas

            // Llama al servicio de logout y redirige al login
            UserService.logout().then(() => this.props.history.push("/login"));
        });
    };

    handleNewChangePasswordTab = (url) => {
        window.open(url);
        sessionStorage.setItem('passwordExpiredAcknowledged', 'true'); // ← NUEVO
        this.setState({
            openDialog: false,
            passwordExpired: false,
            passwordExpiredAcknowledged: true
        });
    };

    handleHeaderColor = () => {
        const location = this.props.location.pathname;
        let headerColor = 'Header'

        if (location.startsWith('/cost')) headerColor = 'HeaderColorCost'
        else if (location.startsWith('/mac')) headerColor = 'HeaderColorMac'
        else if (location.startsWith('/lima')) headerColor = 'HeaderColorLima'
        else if (location.startsWith('/medi')) headerColor = 'HeaderColorMedi'
        else if (location.startsWith('/bas')) headerColor = 'HeaderColorBas'
        else if (location.startsWith('/spac')) headerColor = 'HeaderColorSpac'
        else if (location.startsWith('/adm')) headerColor = 'HeaderColorAdm'

        return headerColor;
    };

    render() {
        const {
            anchorEl,
            mobileMoreAnchorEl,
            passwordExpired,
        } = this.state;

        const { classes, daysToPasswordExpiration, passwordExpires } = this.props;
        const isMenuOpen = Boolean(anchorEl);
        const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
        const headerColor = this.handleHeaderColor();

        const pwdResetURL = `${process.env.REACT_APP_PWD_RESET_URL}`;

        const renderMenu = (
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                open={isMenuOpen}
                onClose={this.handleMenuClose}
            >
                <MenuItem disabled={!passwordExpires || !pwdResetURL} onClick={() => this.handleNewChangePasswordTab(pwdResetURL)}>
                    Cambiar contraseña
                </MenuItem>
                <MenuItem onClick={this.logout}>Salir</MenuItem>
            </Menu>
        );

        const renderMobileMenu = (
            <Menu
                anchorEl={mobileMoreAnchorEl}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                open={isMobileMenuOpen}
                onClose={this.handleMobileMenuClose}
            >
                <MenuItem>
                    <IconButton
                        className="UserButton"
                        aria-owns={isMenuOpen ? "material-appbar" : null}
                        aria-haspopup="true"
                        onClick={this.handleProfileMenuOpen}
                        color="inherit"
                    >
                        <AccountCircle />
                    </IconButton>
                </MenuItem>
                <MenuItem>
                    <IconButton
                        color="inherit"
                        aria-label="Favoritos"
                        onClick={this.props.toggleDrawer("right", true)}
                    >
                        <Star />
                    </IconButton>
                </MenuItem>
                <MenuItem>
                     <IconButton
                    onClick={() =>
                    window.open(`${process.env.REACT_APP_BASE_URL}/`)}
                    size="medium"
                    color="inherit"
                    aria-label="More"
                    >
                        <LibraryAdd />
                    </IconButton>
                </MenuItem>
            </Menu>
        );

        return (

            <>
                <div className={headerColor}>
                    <AppBar
                        position="absolute"
                        className={classNames(
                            classes.appBar,
                            this.props.open && classes.appBarShift
                        )}
                    >
                        <Toolbar disableGutters={this.props.open} className={classes.toolbar}>
                            {!this.props.open && (
                                <IconButton
                                    color="inherit"
                                    aria-label="Open drawer"
                                    onClick={this.props.toggle}
                                    className={classNames(
                                        classes.menuButton,
                                        this.props.open && classes.menuButtonHidden
                                    )}
                                >
                                    <MenuIcon />
                                </IconButton>
                            )}
                            <Grid direction="row" container style={{ width: "100%" }}>
                                <Grid id="navPath" container justifyContent="flex-start" />
                                <Grid id="keypadComponent" container justifyContent="flex-end" />
                            </Grid>

                            <ConfirmationDialog
                                dialogHandler={this.deslogearDialogHandler}
                                title="Atención"
                                message={`¿Está seguro que desea salir de la aplicación?`}
                            />

                            {this.state.etgsNotification && (
                                <Tooltip
                                    title={<Typography color="inherit">{this.state.etgsNotification.message}</Typography>}
                                    placement="bottom"
                                >
                                    <IconButton color="inherit">
                                        <NotificationsIcon color="error" />
                                    </IconButton>
                                </Tooltip>
                            )}

                            <div className={classes.grow} />
                            <div className={classes.sectionDesktop}>
                                <div className="UserDivIcon">
                                    <IconButton
                                        size="small"
                                        className="UserButton"
                                        aria-owns={isMenuOpen ? "material-appbar" : null}
                                        aria-haspopup="true"
                                        onClick={this.handleProfileMenuOpen}
                                        color="inherit"
                                    >
                                        <AccountCircle />
                                    </IconButton>
                                    <p>{this.props.context.userName}</p>
                                </div>
                                <div className="favoriteIcons">
                                    <IconButton
                                        id="icon"
                                        size="small"
                                        color="inherit"
                                        aria-label="Favoritos"
                                        onClick={this.props.toggleDrawer("right", true)}
                                    >
                                        <Star />
                                    </IconButton>
                                    <DrawerLeft
                                        toggleDrawer={this.props.toggleDrawer}
                                        right={this.props.right}
                                    />
                                    <IconButton
                                        onClick={() =>
                                            window.open(`${process.env.REACT_APP_BASE_URL}/`)
                                        }
                                        size="medium"
                                        color="inherit"
                                        aria-label="More"
                                    >
                                        <LibraryAdd />
                                    </IconButton>
                                </div>
                            </div>
                            <div className={classes.sectionMobile}>
                                <IconButton
                                    aria-haspopup="true"
                                    size="small"
                                    onClick={this.handleMobileMenuOpen}
                                    color="inherit"
                                >
                                    <MoreIcon />
                                </IconButton>
                            </div>
                        </Toolbar>
                        {(this.state.etgsNotification && this.state.showAlert) && (
                            <Box width={"100%"}>
                                <Alert severity="warning" onClose={() => { this.setState({showAlert:false})}}>{this.state.etgsNotification.message}</Alert>
                            </Box>
                        )}
                    </AppBar>
                    {renderMenu}
                    {renderMobileMenu}

                </div>

                <CommonDialog
                    open={passwordExpired}
                    disableBackdropClick
                    maxWidth="sm"
                    title={'eTGS'}
                    margin="-20px"
                    aceptarText="SI"
                    cancelarText="NO"
                    noAceptar={true}
                    extraButtons={
                        <Button color="primary"
                                onClick={() => this.handleNewChangePasswordTab(pwdResetURL)}
                        >
                            SI
                        </Button>
                    }
                    onClickCancelar={() => {
                        sessionStorage.setItem('passwordExpiredAcknowledged', 'true');
                        this.setState({
                            oldPassword: "",
                            newPassword: "",
                            retryNewPassword: "",
                            openDialog: false,
                            passwordExpired: false,
                            passwordExpiredAcknowledged: true
                        })
                    }}
                >
                    {`Su contraseña está por expirar en ${daysToPasswordExpiration} días ¿ Desea modificarla ahora ?`}
                </CommonDialog>

                {/** ALERTAS */}
                <CommonDialog
                    open={this.state.alert.open}
                    backgroundTitle={this.state.alert.error ? 'rgb(241, 206, 47)' : 'rgb(0,128,0)'}
                    disableBackdropClick
                    maxWidth="sm"
                    title="ATENCIÓN"
                    margin="-20px"
                    noCancelar
                    aceptarText="Continuar"
                    onClickAceptar={() => this.setState({ alert: { message: '', open: false, error: false } })}>
                    {this.state.alert.message}
                </CommonDialog>
            </>
        );
    }
}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    context: PropTypes.shape({
        userName: PropTypes.string
    }).isRequired,
    open: PropTypes.bool,
    toggle: PropTypes.func,
    toggleDrawer: PropTypes.func,
    right: PropTypes.bool,
    passwordStatus: PropTypes.string,
    passwordExpires: PropTypes.bool,
    daysToPasswordExpiration: PropTypes.number,
};

Header.defaultProps = {
    open: false,
    toggle: null,
    toggleDrawer: () => () => {},
    right: false,
    passwordStatus: null,
    passwordExpires: false,
    daysToPasswordExpiration: 0,
};

export default withRouter(withStyles(styles)(withContext(Header)));
